export default {
  title: {
    ar: 'اختبر معلوماتك عن "وراء كل وجبة قصة"',
    en: 'Play the quiz to test all what you know about the good you don\'t order!'
  },

  description: {
    ar: 'أجب بطريقة صحيحة عن سؤال واحد من أصل ثلاثة لتشارك في السحب على فرصة ربح جلسات بادل لك أو لطفلك. عد غدًا والعب مجددًا لزيادة فرصك في الفوز.',
    en: 'Get <b>1 out of 3 answers</b> correct to enter the raffle draw for a chance to <b>win padel sessions for you or your kid</b>.<br> Come back tomorrow and play again to increase your chances.',
  },

  button: {
    ar: '!هيا بنا',
    en: 'Let\'s go!'
  },

  terms: {
    ar: '',
    en: 'Have a look at the'
  },

  termsLabel: {
    ar: 'اطلع على الشروط والأحكام',
    en: 'Terms & Conditions'
  },

  termsLink: {
    ar: 'https://storage.googleapis.com/media-mcd-uae-fanshop-prod/terms/Brand_Trust_Game.pdf?openOutsideMcd=true',
    en: 'https://storage.googleapis.com/media-mcd-uae-fanshop-prod/terms/Brand_Trust_Game.pdf?openOutsideMcd=true'
  }
};
